export default __webpack_public_path__ + "static/media/img11.f2b0835a.jpg";